var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"orderPage"},[_c('div',{staticClass:"head"},[_c('NavBar'),_c('div',{class:'collapse'},[_c('Menu')],1)],1),_c('div',{class:[{ hasFilters: _vm.showFilters }, 'orderPageContent']},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }